module.exports = "https://trybtryb-legacy.web.app/img/digital.64f05089.svg";